export default {
    productDonation() {
        return axios.get("/api/ecommerce/store/productDonation");
    },
};
